// Mock data for Mikado Sushi - Final Menu with Corrected Translations

export const featuredSushi = [
  {
    id: 101,
    name: "Royal Philadelphia",
    nameTranslations: {
      en: "Royal Philadelphia",
      lv: "Royal Philadelphia",
      ru: "Royal Philadelphia"
    },
    description: "Rice, nori, salmon, cream cheese, shrimp, avocado, red masago roe",
    descriptionTranslations: {
      en: "Rice, nori, salmon, cream cheese, shrimp, avocado, red masago roe",
      lv: "Rīsi, nori, lasis, krēmsiers, garneles, avokado, sarkanie masago ikri",
      ru: "Рис, нори, лосось, сливочный сыр, креветки, авокадо, красная икра масаго"
    },
    allergens: [3, 5, 7],
    price: 14.00,
    image: "https://customer-assets.emergentagent.com/job_premium-delivery-6/artifacts/4ec29r1e_Phila%20Royal.JPG",
    category: "maki-rolls",
    popular: true
  },
  {
    id: 103,
    name: "Banzay Maki",
    nameTranslations: {
      en: "Banzay Maki",
      lv: "Banzay Maki",
      ru: "Banzay Maki"
    },
    description: "Rice, nori, tempura shrimp, tobiko roe, avocado, trout roe",
    descriptionTranslations: {
      en: "Rice, nori, tempura shrimp, tobiko roe, avocado, trout roe",
      lv: "Rīsi, nori, tempura garneles, tobiko ikri, avokado, foreles ikri",
      ru: "Рис, нори, креветки темпура, икра тобико, авокадо, икра форели"
    },
    allergens: [2, 3, 4, 5, 12],
    price: 15.00,
    image: "https://customer-assets.emergentagent.com/job_premium-delivery-6/artifacts/unfc9qbo_Banzai%20%281%29.JPG",
    category: "maki-rolls",
    popular: true
  },
  {
    id: 106,
    name: "California",
    nameTranslations: {
      en: "California",
      lv: "California",
      ru: "California"
    },
    description: "Rice, crab, mayonnaise, avocado, cucumber, red masago roe",
    descriptionTranslations: {
      en: "Rice, crab, mayonnaise, avocado, cucumber, red masago roe",
      lv: "Rīsi, krabis, majonēze, avokado, gurķis, sarkanie masago ikri",
      ru: "Рис, краб, майонез, авокадо, огурец, красная икра масаго"
    },
    allergens: [3, 4, 5],
    price: 10.50,
    image: "https://customer-assets.emergentagent.com/job_premium-delivery-6/artifacts/90ilu615_California.JPG",
    category: "maki-rolls",
    popular: true
  },
  {
    id: 302,
    name: "Poke ar lasi",
    nameTranslations: {
      en: "Salmon Poke",
      lv: "Poke ar lasi",
      ru: "Поке с лососем"
    },
    description: "Rice, salmon, avocado, cucumber, edamame beans, mango, wakame, carrots",
    descriptionTranslations: {
      en: "Rice, salmon, avocado, cucumber, edamame beans, mango, wakame, carrots",
      lv: "Rīsi, lasis, avokado, gurķis, edamamē pupiņas, mango, wakame, burkāni",
      ru: "Рис, лосось, авокадо, огурец, бобы эдамамэ, манго, вакамэ, морковь"
    },
    allergens: [5, 12],
    price: 13.00,
    image: "https://customer-assets.emergentagent.com/job_mikado-eats/artifacts/qvnuvgrc_ChatGPT%20Image%2027%20%D0%B4%D0%B5%D0%BA.%202025%20%D0%B3.%2C%2022_57_06.png",
    category: "poke",
    popular: true
  }
];

export const menuCategories = [
  {
    id: "maki-rolls",
    name: "Maki Rolls",
    nameTranslations: {
      en: "Maki Rolls",
      lv: "Maki Ruļļi",
      ru: "Маки-роллы"
    },
    items: [
      { 
        id: 101, 
        name: "Royal Philadelphia",
        nameTranslations: { en: "Royal Philadelphia", lv: "Royal Philadelphia", ru: "Royal Philadelphia" },
        description: "Rice, nori, salmon, cream cheese, shrimp, avocado, red masago roe",
        descriptionTranslations: {
          en: "Rice, nori, salmon, cream cheese, shrimp, avocado, red masago roe",
          lv: "Rīsi, nori, lasis, krēmsiers, garneles, avokado, sarkanie masago ikri",
          ru: "Рис, нори, лосось, сливочный сыр, креветки, авокадо, красная икра масаго"
        },
        allergens: [3, 5, 7],
        price: 14.00, 
        image: "https://customer-assets.emergentagent.com/job_premium-delivery-6/artifacts/4ec29r1e_Phila%20Royal.JPG"
      },
      { 
        id: 102, 
        name: "Green Dragon Maki",
        nameTranslations: { en: "Green Dragon Maki", lv: "Green Dragon Maki", ru: "Green Dragon Maki" },
        description: "Rice, nori, salmon, eel, avocado, mango, seaweed, unagi sauce",
        descriptionTranslations: {
          en: "Rice, nori, salmon, eel, avocado, mango, seaweed, unagi sauce",
          lv: "Rīsi, nori, lasis, zutis, avokado, mango, jūras aļģes, unagi mērce",
          ru: "Рис, нори, лосось, угорь, авокадо, манго, морские водоросли, соус унаги"
        },
        allergens: [2, 5, 12],
        price: 12.50, 
        image: "https://customer-assets.emergentagent.com/job_premium-delivery-6/artifacts/1udomd00_Green%20dragon%20makio.JPG"
      },
      { 
        id: 103, 
        name: "Banzay Maki",
        nameTranslations: { en: "Banzay Maki", lv: "Banzay Maki", ru: "Banzay Maki" },
        description: "Rice, nori, tempura shrimp, tobiko roe, avocado, trout roe",
        descriptionTranslations: {
          en: "Rice, nori, tempura shrimp, tobiko roe, avocado, trout roe",
          lv: "Rīsi, nori, tempura garneles, tobiko ikri, avokado, foreles ikri",
          ru: "Рис, нори, креветки темпура, икра тобико, авокадо, икра форели"
        },
        allergens: [2, 3, 4, 5, 12],
        price: 15.00, 
        image: "https://customer-assets.emergentagent.com/job_premium-delivery-6/artifacts/unfc9qbo_Banzai%20%281%29.JPG"
      },
      { 
        id: 104, 
        name: "Philadelphia Lux",
        nameTranslations: { en: "Philadelphia Lux", lv: "Philadelphia Lux", ru: "Philadelphia Lux" },
        description: "Rice, nori, salmon, avocado, shrimp, cream cheese, trout roe",
        descriptionTranslations: {
          en: "Rice, nori, salmon, avocado, shrimp, cream cheese, trout roe",
          lv: "Rīsi, nori, lasis, avokado, garneles, krēmsiers, foreles ikri",
          ru: "Рис, нори, лосось, авокадо, креветки, сливочный сыр, икра форели"
        },
        allergens: [3, 5, 7],
        price: 16.00, 
        image: "https://customer-assets.emergentagent.com/job_premium-delivery-6/artifacts/f0v4ixji_Phila%20Lux.JPG"
      },
      { 
        id: 105, 
        name: "Samurai Maki",
        nameTranslations: { en: "Samurai Maki", lv: "Samurai Maki", ru: "Samurai Maki" },
        description: "Rice, nori, cucumber, avocado, salmon, shrimp, cream cheese",
        descriptionTranslations: {
          en: "Rice, nori, cucumber, avocado, salmon, shrimp, cream cheese",
          lv: "Rīsi, nori, gurķis, avokado, lasis, garneles, krēmsiers",
          ru: "Рис, нори, огурец, авокадо, лосось, креветки, сливочный сыр"
        },
        allergens: [3, 5, 7],
        price: 12.00, 
        image: "https://customer-assets.emergentagent.com/job_premium-delivery-6/artifacts/042dbsfx_Samurai.JPG"
      },
      { 
        id: 106, 
        name: "California",
        nameTranslations: { en: "California", lv: "California", ru: "California" },
        description: "Rice, crab, mayonnaise, avocado, cucumber, red masago roe",
        descriptionTranslations: {
          en: "Rice, crab, mayonnaise, avocado, cucumber, red masago roe",
          lv: "Rīsi, krabis, majonēze, avokado, gurķis, sarkanie masago ikri",
          ru: "Рис, краб, майонез, авокадо, огурец, красная икра масаго"
        },
        allergens: [3, 4, 5],
        price: 10.50, 
        image: "https://customer-assets.emergentagent.com/job_premium-delivery-6/artifacts/90ilu615_California.JPG"
      },
      { 
        id: 107, 
        name: "California Ebi Black",
        nameTranslations: { en: "California Ebi Black", lv: "California Ebi Black", ru: "California Ebi Black" },
        description: "Rice, nori, shrimp, mayonnaise, cucumber, avocado, black masago roe",
        descriptionTranslations: {
          en: "Rice, nori, shrimp, mayonnaise, cucumber, avocado, black masago roe",
          lv: "Rīsi, nori, garneles, majonēze, gurķis, avokado, melnie masago ikri",
          ru: "Рис, нори, креветки, майонез, огурец, авокадо, черная икра масаго"
        },
        allergens: [3, 4, 5],
        price: 10.00, 
        image: "https://customer-assets.emergentagent.com/job_premium-delivery-6/artifacts/qqbmek2r_Cali%20Ebi%20black.JPG"
      },
      { 
        id: 108, 
        name: "Philadelphia Black",
        nameTranslations: { en: "Philadelphia Black", lv: "Philadelphia Black", ru: "Philadelphia Black" },
        description: "Rice, nori, salmon, avocado, cucumber, cream cheese, black masago roe",
        descriptionTranslations: {
          en: "Rice, nori, salmon, avocado, cucumber, cream cheese, black masago roe",
          lv: "Rīsi, nori, lasis, avokado, gurķis, krēmsiers, melnie masago ikri",
          ru: "Рис, нори, лосось, авокадо, огурец, сливочный сыр, черная икра масаго"
        },
        allergens: [5, 7],
        price: 16.00, 
        image: "https://customer-assets.emergentagent.com/job_premium-delivery-6/artifacts/3q97nrwx_Phila%20Black.JPG"
      },
      { 
        id: 109, 
        name: "Philadelphia Classic",
        nameTranslations: { en: "Philadelphia Classic", lv: "Philadelphia Classic", ru: "Philadelphia Classic" },
        description: "Rice, nori, salmon, cream cheese, avocado, cucumber",
        descriptionTranslations: {
          en: "Rice, nori, salmon, cream cheese, avocado, cucumber",
          lv: "Rīsi, nori, lasis, krēmsiers, avokado, gurķis",
          ru: "Рис, нори, лосось, сливочный сыр, авокадо, огурец"
        },
        allergens: [5, 7],
        price: 11.00, 
        image: "https://customer-assets.emergentagent.com/job_premium-delivery-6/artifacts/m75jr5ac_Phila.JPG"
      },
      { 
        id: 110, 
        name: "Philadelphia Sezam",
        nameTranslations: { en: "Philadelphia Sesame", lv: "Philadelphia Sezam", ru: "Philadelphia Sezam" },
        description: "Rice, nori, salmon, cream cheese, avocado, cucumber, sesame",
        descriptionTranslations: {
          en: "Rice, nori, salmon, cream cheese, avocado, cucumber, sesame",
          lv: "Rīsi, nori, lasis, krēmsiers, avokado, gurķis, sezams",
          ru: "Рис, нори, лосось, сливочный сыр, авокадо, огурец, кунжут"
        },
        allergens: [5, 7, 11],
        price: 10.00, 
        image: "https://customer-assets.emergentagent.com/job_premium-delivery-6/artifacts/rxm10f6v_Phila%20Sezam.JPG"
      },
      { 
        id: 111, 
        name: "Philadelphia Gold",
        nameTranslations: { en: "Philadelphia Gold", lv: "Philadelphia Gold", ru: "Philadelphia Gold" },
        description: "Rice, nori, salmon, cream cheese, avocado, cucumber, red masago roe",
        descriptionTranslations: {
          en: "Rice, nori, salmon, cream cheese, avocado, cucumber, red masago roe",
          lv: "Rīsi, nori, lasis, krēmsiers, avokado, gurķis, sarkanie masago ikri",
          ru: "Рис, нори, лосось, сливочный сыр, авокадо, огурец, красная икра масаго"
        },
        allergens: [5, 7],
        price: 11.00, 
        image: "https://customer-assets.emergentagent.com/job_premium-delivery-6/artifacts/yk8lovur_Phila%20gold.JPG"
      },
      { 
        id: 112, 
        name: "Sake-Avakado Maki",
        nameTranslations: { en: "Salmon-Avocado Maki", lv: "Sake-Avakado Maki", ru: "Sake-Avakado Maki" },
        description: "Rice, nori, salmon, avocado",
        descriptionTranslations: {
          en: "Rice, nori, salmon, avocado",
          lv: "Rīsi, nori, lasis, avokado",
          ru: "Рис, нори, лосось, авокадо"
        },
        allergens: [5],
        price: 8.50, 
        image: "https://customer-assets.emergentagent.com/job_premium-delivery-6/artifacts/aqvwrtkr_Avokado%20saki%20maki%20%281%29.JPG"
      },
      { 
        id: 113, 
        name: "Dragon Maki",
        nameTranslations: { en: "Dragon Maki", lv: "Dragon Maki", ru: "Dragon Maki" },
        description: "Rice, nori, eel, avocado, cucumber, cream cheese, unagi sauce, sesame",
        descriptionTranslations: {
          en: "Rice, nori, eel, avocado, cucumber, cream cheese, unagi sauce, sesame",
          lv: "Rīsi, nori, zutis, avokado, gurķis, krēmsiers, unagi mērce, sezams",
          ru: "Рис, нори, угорь, авокадо, огурец, сливочный сыр, соус унаги, кунжут"
        },
        allergens: [2, 5, 7, 11, 12],
        price: 13.00, 
        image: "https://customer-assets.emergentagent.com/job_premium-delivery-6/artifacts/gdm5pjf1_Dragon%20maki.JPG"
      },
      { 
        id: 114, 
        name: "Royal Dragon Maki",
        nameTranslations: { en: "Royal Dragon Maki", lv: "Royal Dragon Maki", ru: "Royal Dragon Maki" },
        description: "Rice, nori, crab, eel, cream cheese, avocado, red masago roe, unagi sauce, sesame",
        descriptionTranslations: {
          en: "Rice, nori, crab, eel, cream cheese, avocado, red masago roe, unagi sauce, sesame",
          lv: "Rīsi, nori, krabis, zutis, krēmsiers, avokado, sarkanie masago ikri, unagi mērce, sezams",
          ru: "Рис, нори, краб, угорь, сливочный сыр, авокадо, красная икра масаго, соус унаги, кунжут"
        },
        allergens: [2, 3, 5, 7, 11, 12],
        price: 14.50, 
        image: "https://customer-assets.emergentagent.com/job_premium-delivery-6/artifacts/j1jli5rd_Royal%20Dragon.jpg"
      },
      { 
        id: 115, 
        name: "Gesha Maki",
        nameTranslations: { en: "Geisha Maki", lv: "Gesha Maki", ru: "Gesha Maki" },
        description: "Rice, nori, salmon, shrimp, avocado, cream cheese, red masago roe",
        descriptionTranslations: {
          en: "Rice, nori, salmon, shrimp, avocado, cream cheese, red masago roe",
          lv: "Rīsi, nori, lasis, garneles, avokado, krēmsiers, sarkanie masago ikri",
          ru: "Рис, нори, лосось, креветки, авокадо, сливочный сыр, красная икра масаго"
        },
        allergens: [3, 5, 7],
        price: 12.00, 
        image: "https://customer-assets.emergentagent.com/job_premium-delivery-6/artifacts/8giyceqy_Geisha.JPG"
      },
      { 
        id: 116, 
        name: "Maguro Maki",
        nameTranslations: { en: "Tuna Maki", lv: "Maguro Maki", ru: "Maguro Maki" },
        description: "Rice, nori, tuna, avocado, cucumber, seaweed, cream cheese",
        descriptionTranslations: {
          en: "Rice, nori, tuna, avocado, cucumber, seaweed, cream cheese",
          lv: "Rīsi, nori, tuncis, avokado, gurķis, jūras aļģes, krēmsiers",
          ru: "Рис, нори, тунец, авокадо, огурец, водоросли, сливочный сыр"
        },
        allergens: [5, 7],
        price: 11.50, 
        image: "https://customer-assets.emergentagent.com/job_premium-delivery-6/artifacts/q7xmysds_Magura.JPG"
      },
      { 
        id: 117, 
        name: "Sakeyaki Maki",
        nameTranslations: { en: "Sakeyaki Maki", lv: "Sakeyaki Maki", ru: "Sakeyaki Maki" },
        description: "Rice, nori, salmon, avocado, tobiko roe, spicy sauce, cream cheese",
        descriptionTranslations: {
          en: "Rice, nori, salmon, avocado, tobiko roe, spicy sauce, cream cheese",
          lv: "Rīsi, nori, lasis, avokado, tobiko ikri, pikanta mērce, krēmsiers",
          ru: "Рис, нори, лосось, авокадо, икра тобико, острый соус, сливочный сыр"
        },
        allergens: [4, 5, 7],
        price: 15.00, 
        image: "https://customer-assets.emergentagent.com/job_premium-delivery-6/artifacts/k3555oel_Saki%20Yaki.JPG"
      },
      { 
        id: 118, 
        name: "Spicy Maguro",
        nameTranslations: { en: "Spicy Tuna", lv: "Spicy Maguro", ru: "Spicy Maguro" },
        description: "Rice, nori, tuna, avocado, seaweed, red masago roe",
        descriptionTranslations: {
          en: "Rice, nori, tuna, avocado, seaweed, red masago roe",
          lv: "Rīsi, nori, tuncis, avokado, jūras aļģes, sarkanie masago ikri",
          ru: "Рис, нори, тунец, авокадо, водоросли, красная икра масаго"
        },
        allergens: [5],
        price: 8.00, 
        image: "https://customer-assets.emergentagent.com/job_premium-delivery-6/artifacts/fkxuuagu_Spicy%20Mugaro.JPG"
      },
      { 
        id: 119, 
        name: "Sake Tempura",
        nameTranslations: { en: "Salmon Tempura", lv: "Sake Tempura", ru: "Sake Tempura" },
        description: "Rice, nori, salmon, avocado, cucumber, cream cheese, unagi sauce, tempura, panko",
        descriptionTranslations: {
          en: "Rice, nori, salmon, avocado, cucumber, cream cheese, unagi sauce, tempura, panko",
          lv: "Rīsi, nori, lasis, avokado, gurķis, krēmsiers, unagi mērce, tempura, panko",
          ru: "Рис, нори, лосось, авокадо, огурец, сливочный сыр, соус унаги, темпура, панко"
        },
        allergens: [2, 4, 5, 7, 12],
        price: 10.50, 
        image: "https://customer-assets.emergentagent.com/job_premium-delivery-6/artifacts/7jvx0m4x_Saki%20tempura.JPG"
      },
      { 
        id: 120, 
        name: "Ebi Tempura",
        nameTranslations: { en: "Shrimp Tempura", lv: "Ebi Tempura", ru: "Ebi Tempura" },
        description: "Rice, nori, shrimp, avocado, cucumber, cream cheese, unagi sauce, tempura, panko",
        descriptionTranslations: {
          en: "Rice, nori, shrimp, avocado, cucumber, cream cheese, unagi sauce, tempura, panko",
          lv: "Rīsi, nori, garneles, avokado, gurķis, krēmsiers, unagi mērce, tempura, panko",
          ru: "Рис, нори, креветки, авокадо, огурец, сливочный сыр, соус унаги, темпура, панко"
        },
        allergens: [2, 3, 4, 7, 12],
        price: 10.50, 
        image: "https://customer-assets.emergentagent.com/job_premium-delivery-6/artifacts/kadp095y_Ebi%20Tempura%20%281%29.JPG"
      },
      { 
        id: 121, 
        name: "Unagi Tempura",
        nameTranslations: { en: "Eel Tempura", lv: "Unagi Tempura", ru: "Unagi Tempura" },
        description: "Rice, nori, eel, avocado, cream cheese, unagi sauce, tempura, panko",
        descriptionTranslations: {
          en: "Rice, nori, eel, avocado, cream cheese, unagi sauce, tempura, panko",
          lv: "Rīsi, nori, zutis, avokado, krēmsiers, unagi mērce, tempura, panko",
          ru: "Рис, нори, угорь, авокадо, сливочный сыр, соус унаги, темпура, панко"
        },
        allergens: [2, 4, 5, 7, 12],
        price: 14.00, 
        image: "https://customer-assets.emergentagent.com/job_premium-delivery-6/artifacts/4h6j1sod_Unagi%20tempura.JPG"
      },
      { 
        id: 122, 
        name: "Mango Tempura",
        nameTranslations: { en: "Mango Tempura", lv: "Mango Tempura", ru: "Mango Tempura" },
        description: "Rice, nori, salmon, cream cheese, avocado, mango, red masago roe, unagi sauce, tempura, panko",
        descriptionTranslations: {
          en: "Rice, nori, salmon, cream cheese, avocado, mango, red masago roe, unagi sauce, tempura, panko",
          lv: "Rīsi, nori, lasis, krēmsiers, avokado, mango, sarkanie masago ikri, unagi mērce, tempura, panko",
          ru: "Рис, нори, лосось, сливочный сыр, авокадо, манго, красная икра масаго, соус унаги, темпура, панко"
        },
        allergens: [2, 4, 5, 7, 12],
        price: 12.00, 
        image: "https://customer-assets.emergentagent.com/job_premium-delivery-6/artifacts/ls4nqnow_Mango%20Tempura.JPG"
      },
      { 
        id: 123, 
        name: "Sake Hosomaki",
        nameTranslations: { en: "Salmon Hosomaki", lv: "Sake Hosomaki", ru: "Sake Hosomaki" },
        description: "Rice, nori, salmon",
        descriptionTranslations: {
          en: "Rice, nori, salmon",
          lv: "Rīsi, nori, lasis",
          ru: "Рис, нори, лосось"
        },
        allergens: [5],
        price: 5.50, 
        image: "https://customer-assets.emergentagent.com/job_premium-delivery-6/artifacts/1c8un1ss_Salmon%20maki.JPG"
      },
      { 
        id: 124, 
        name: "Unagi Hosomaki",
        nameTranslations: { en: "Eel Hosomaki", lv: "Unagi Hosomaki", ru: "Unagi Hosomaki" },
        description: "Rice, nori, eel",
        descriptionTranslations: {
          en: "Rice, nori, eel",
          lv: "Rīsi, nori, zutis",
          ru: "Рис, нори, угорь"
        },
        allergens: [5],
        price: 6.50, 
        image: "https://customer-assets.emergentagent.com/job_premium-delivery-6/artifacts/16jy9tgw_Unagi%20maki.JPG"
      },
      { 
        id: 125, 
        name: "Tuna Hosomaki",
        nameTranslations: { en: "Tuna Hosomaki", lv: "Tuna Hosomaki", ru: "Tuna Hosomaki" },
        description: "Rice, nori, tuna",
        descriptionTranslations: {
          en: "Rice, nori, tuna",
          lv: "Rīsi, nori, tuncis",
          ru: "Рис, нори, тунец"
        },
        allergens: [5],
        price: 6.00, 
        image: "https://customer-assets.emergentagent.com/job_premium-delivery-6/artifacts/95frx077_Tuna%20maki.JPG"
      },
      { 
        id: 126, 
        name: "Avakado Hosomaki",
        nameTranslations: { en: "Avocado Hosomaki", lv: "Avakado Hosomaki", ru: "Avakado Hosomaki" },
        description: "Rice, nori, avocado",
        descriptionTranslations: {
          en: "Rice, nori, avocado",
          lv: "Rīsi, nori, avokado",
          ru: "Рис, нори, авокадо"
        },
        allergens: [],
        price: 3.50, 
        image: "https://customer-assets.emergentagent.com/job_premium-delivery-6/artifacts/0ugx15i4_Avokado%20maki.JPG"
      },
      { 
        id: 127, 
        name: "Kappa Hosomaki",
        nameTranslations: { en: "Cucumber Hosomaki", lv: "Kappa Hosomaki", ru: "Kappa Hosomaki" },
        description: "Rice, nori, cucumber",
        descriptionTranslations: {
          en: "Rice, nori, cucumber",
          lv: "Rīsi, nori, gurķis",
          ru: "Рис, нори, огурец"
        },
        allergens: [],
        price: 3.00, 
        image: "https://customer-assets.emergentagent.com/job_premium-delivery-6/artifacts/kp89yeqo_Kapa%20maki.JPG"
      },
      { 
        id: 128, 
        name: "Wakame Hosomaki",
        nameTranslations: { en: "Wakame Hosomaki", lv: "Wakame Hosomaki", ru: "Wakame Hosomaki" },
        description: "Rice, nori, seaweed",
        descriptionTranslations: {
          en: "Rice, nori, seaweed",
          lv: "Rīsi, nori, jūras aļģes",
          ru: "Рис, нори, водоросли"
        },
        allergens: [],
        price: 3.00, 
        image: "https://customer-assets.emergentagent.com/job_premium-delivery-6/artifacts/w17v1ycn_Wakame%20maki.JPG"
      }
    ]
  },
  {
    id: "vegan-maki",
    name: "Vegan Maki",
    nameTranslations: {
      en: "Vegan Maki",
      lv: "Vegāniskie Maki",
      ru: "Веганские Маки"
    },
    items: [
      { 
        id: 201, 
        name: "Kappa-Avakado Maki",
        nameTranslations: { en: "Cucumber-Avocado Maki", lv: "Kappa-Avakado Maki", ru: "Kappa-Avakado Maki" },
        description: "Rice, nori, cucumber, avocado, lettuce, cream cheese, sesame",
        descriptionTranslations: {
          en: "Rice, nori, cucumber, avocado, lettuce, cream cheese, sesame",
          lv: "Rīsi, nori, gurķis, avokado, salāti, krēmsiers, sezams",
          ru: "Рис, нори, огурец, авокадо, салат, сливочный сыр, кунжут"
        },
        allergens: [7, 11],
        price: 8.00, 
        image: "https://customer-assets.emergentagent.com/job_premium-delivery-6/artifacts/2kab9my0_Kapa%20avokado%20maki.JPG"
      },
      { 
        id: 202, 
        name: "Fargo Maki",
        nameTranslations: { en: "Fargo Maki", lv: "Fargo Maki", ru: "Fargo Maki" },
        description: "Rice, nori, cucumber, tomatoes, green onion, cream cheese, fried onions",
        descriptionTranslations: {
          en: "Rice, nori, cucumber, tomatoes, green onion, cream cheese, fried onions",
          lv: "Rīsi, nori, gurķis, tomāti, zaļais lociņš, krēmsiers, cepti sīpoli",
          ru: "Рис, нори, огурец, помидоры, зеленый лук, сливочный сыр, жареный лук"
        },
        allergens: [2, 7],
        price: 7.00, 
        image: "https://customer-assets.emergentagent.com/job_premium-delivery-6/artifacts/a8n4cnmr_Fargo.JPG"
      },
      { 
        id: 203, 
        name: "Veggie Tempura Maki",
        nameTranslations: { en: "Veggie Tempura Maki", lv: "Veggie Tempura Maki", ru: "Veggie Tempura Maki" },
        description: "Rice, nori, tomatoes, cream cheese, avocado, seaweed, unagi sauce, tempura, panko",
        descriptionTranslations: {
          en: "Rice, nori, tomatoes, cream cheese, avocado, seaweed, unagi sauce, tempura, panko",
          lv: "Rīsi, nori, tomāti, krēmsiers, avokado, jūras aļģes, unagi mērce, tempura, panko",
          ru: "Рис, нори, помидоры, сливочный сыр, авокадо, водоросли, соус унаги, темпура, панко"
        },
        allergens: [2, 4, 7, 12],
        price: 8.50, 
        image: "https://customer-assets.emergentagent.com/job_premium-delivery-6/artifacts/jsqemfjj_Veggi%20tempura.JPG"
      }
    ]
  },
  {
    id: "poke",
    name: "Poke",
    nameTranslations: {
      en: "Poke Bowls",
      lv: "Poke Bļodas",
      ru: "Поке-боулы"
    },
    items: [
      { 
        id: 301, 
        name: "Poke ar garnelēm",
        nameTranslations: { en: "Shrimp Poke", lv: "Poke ar garnelēm", ru: "Поке с креветками" },
        description: "Rice, shrimp, avocado, cucumber, edamame beans, mango, wakame, carrots",
        descriptionTranslations: {
          en: "Rice, shrimp, avocado, cucumber, edamame beans, mango, wakame, carrots",
          lv: "Rīsi, garneles, avokado, gurķis, edamamē pupiņas, mango, wakame, burkāni",
          ru: "Рис, креветки, авокадо, огурец, бобы эдамамэ, манго, вакамэ, морковь"
        },
        allergens: [3, 12],
        price: 14.00, 
        image: "https://customer-assets.emergentagent.com/job_mikado-eats/artifacts/w6vv04r1_ChatGPT%20Image%2027%20%D0%B4%D0%B5%D0%BA.%202025%20%D0%B3.%2C%2023_01_24.png"
      },
      { 
        id: 302, 
        name: "Poke ar lasi",
        nameTranslations: { en: "Salmon Poke", lv: "Poke ar lasi", ru: "Поке с лососем" },
        description: "Rice, salmon, avocado, cucumber, edamame beans, mango, wakame, carrots",
        descriptionTranslations: {
          en: "Rice, salmon, avocado, cucumber, edamame beans, mango, wakame, carrots",
          lv: "Rīsi, lasis, avokado, gurķis, edamamē pupiņas, mango, wakame, burkāni",
          ru: "Рис, лосось, авокадо, огурец, бобы эдамамэ, манго, вакамэ, морковь"
        },
        allergens: [5, 12],
        price: 14.00, 
        image: "https://customer-assets.emergentagent.com/job_mikado-eats/artifacts/qvnuvgrc_ChatGPT%20Image%2027%20%D0%B4%D0%B5%D0%BA.%202025%20%D0%B3.%2C%2022_57_06.png"
      },
      { 
        id: 303, 
        name: "Poke ar vistu",
        nameTranslations: { en: "Chicken Poke", lv: "Poke ar vistu", ru: "Поке с курицей" },
        description: "Rice, chicken, avocado, cucumber, edamame beans, mango, wakame, carrots",
        descriptionTranslations: {
          en: "Rice, chicken, avocado, cucumber, edamame beans, mango, wakame, carrots",
          lv: "Rīsi, vista, avokado, gurķis, edamamē pupiņas, mango, wakame, burkāni",
          ru: "Рис, курица, авокадо, огурец, бобы эдамамэ, манго, вакамэ, морковь"
        },
        allergens: [12],
        price: 12.00, 
        image: "https://customer-assets.emergentagent.com/job_mikado-eats/artifacts/l05lj3ob_ChatGPT%20Image%2027%20%D0%B4%D0%B5%D0%BA.%202025%20%D0%B3.%2C%2022_59_54.png"
      },
      { 
        id: 304, 
        name: "Poke ar laša tartaru",
        nameTranslations: { en: "Salmon Tartare Poke", lv: "Poke ar laša tartaru", ru: "Поке с тартаром из лосося" },
        description: "Rice, salmon tartare, avocado, cucumber, edamame beans, mango, wakame, carrots",
        descriptionTranslations: {
          en: "Rice, salmon tartare, avocado, cucumber, edamame beans, mango, wakame, carrots",
          lv: "Rīsi, laša tartars, avokado, gurķis, edamamē pupiņas, mango, wakame, burkāni",
          ru: "Рис, тартар из лосося, авокадо, огурец, бобы эдамамэ, манго, вакамэ, морковь"
        },
        allergens: [5, 12],
        price: 14.00, 
        image: "https://customer-assets.emergentagent.com/job_mikado-eats/artifacts/7m1ll28x_Lasa%20tartara%20poke.JPG"
      },
      { 
        id: 305, 
        name: "Poke ar tunča tartaru",
        nameTranslations: { en: "Tuna Tartare Poke", lv: "Poke ar tunča tartaru", ru: "Поке с тартаром из тунца" },
        description: "Rice, tuna tartare, avocado, cucumber, edamame beans, mango, wakame, carrots",
        descriptionTranslations: {
          en: "Rice, tuna tartare, avocado, cucumber, edamame beans, mango, wakame, carrots",
          lv: "Rīsi, tunča tartars, avokado, gurķis, edamamē pupiņas, mango, wakame, burkāni",
          ru: "Рис, тартар из тунца, авокадо, огурец, бобы эдамамэ, манго, вакамэ, морковь"
        },
        allergens: [5, 12],
        price: 15.00, 
        image: "https://customer-assets.emergentagent.com/job_mikado-eats/artifacts/b49loau9_Tuna%20Poke.JPG"
      },
      { 
        id: 306, 
        name: "Poke ar pikanto tunča tartaru",
        nameTranslations: { en: "Spicy Tuna Tartare Poke", lv: "Poke ar pikanto tunča tartaru", ru: "Поке с острым тартаром из тунца" },
        description: "Rice, spicy tuna tartare, avocado, cucumber, edamame beans, mango, wakame, carrots",
        descriptionTranslations: {
          en: "Rice, spicy tuna tartare, avocado, cucumber, edamame beans, mango, wakame, carrots",
          lv: "Rīsi, pikantais tunča tartars, avokado, gurķis, edamamē pupiņas, mango, wakame, burkāni",
          ru: "Рис, острый тартар из тунца, авокадо, огурец, бобы эдамамэ, манго, вакамэ, морковь"
        },
        allergens: [4, 5, 12],
        price: 14.50, 
        image: "https://customer-assets.emergentagent.com/job_mikado-eats/artifacts/b49loau9_Tuna%20Poke.JPG"
      }
    ]
  },
  {
    id: "desserts",
    name: "Desserts",
    nameTranslations: {
      en: "Desserts",
      lv: "Deserti",
      ru: "Десерты"
    },
    items: [
      { 
        id: 401, 
        name: "Mochi Himalayan Salted Caramel",
        nameTranslations: { 
          en: "Mochi Himalayan Salted Caramel", 
          lv: "Mochi Himalaju Sālītā Karamele", 
          ru: "Моти Гималайская Солёная Карамель" 
        },
        description: "Little Moons mochi ice cream with Himalayan salted caramel filling, 6 pieces",
        descriptionTranslations: {
          en: "Little Moons mochi ice cream with Himalayan salted caramel filling, 6 pieces",
          lv: "Little Moons mochi saldējums ar Himalaju sālītās karameles pildījumu, 6 gab.",
          ru: "Моти-мороженое Little Moons с начинкой из гималайской солёной карамели, 6 шт."
        },
        allergens: [7],
        price: 12.00, 
        image: "https://customer-assets.emergentagent.com/job_fresh-sushi-2/artifacts/y8fqhqkb_image.png"
      },
      { 
        id: 402, 
        name: "Mochi Belgian Chocolate",
        nameTranslations: { 
          en: "Mochi Belgian Chocolate", 
          lv: "Mochi Beļģu Šokolāde", 
          ru: "Моти Бельгийский Шоколад" 
        },
        description: "Little Moons mochi ice cream with Belgian chocolate filling, 6 pieces, vegan friendly",
        descriptionTranslations: {
          en: "Little Moons mochi ice cream with Belgian chocolate filling, 6 pieces, vegan friendly",
          lv: "Little Moons mochi saldējums ar Beļģu šokolādes pildījumu, 6 gab., vegāniem draudzīgs",
          ru: "Моти-мороженое Little Moons с начинкой из бельгийского шоколада, 6 шт., подходит для веганов"
        },
        allergens: [7],
        price: 12.00, 
        image: "https://customer-assets.emergentagent.com/job_fresh-sushi-2/artifacts/cwc2kgu4_image.png"
      },
      { 
        id: 403, 
        name: "Mochi Passionfruit & Mango",
        nameTranslations: { 
          en: "Mochi Passionfruit & Mango", 
          lv: "Mochi Pasifloras Auglis un Mango", 
          ru: "Моти Маракуйя и Манго" 
        },
        description: "Little Moons mochi ice cream with passionfruit and mango filling, 6 pieces, vegan friendly",
        descriptionTranslations: {
          en: "Little Moons mochi ice cream with passionfruit and mango filling, 6 pieces, vegan friendly",
          lv: "Little Moons mochi saldējums ar pasifloras augļa un mango pildījumu, 6 gab., vegāniem draudzīgs",
          ru: "Моти-мороженое Little Moons с начинкой из маракуйи и манго, 6 шт., подходит для веганов"
        },
        allergens: [],
        price: 12.00, 
        image: "https://customer-assets.emergentagent.com/job_fresh-sushi-2/artifacts/zek8mw3f_image.png"
      }
    ]
  }
];

export const deliveryInfo = {
  minimumOrder: 20,
  deliveryFee: 2.50,
  freeDeliveryOver: 35,
  estimatedTime: "30 min - 1 hour",
  pickupDiscount: 10,
  deliveryZones: ["All Liepaja"]
};

export let cart = [];

export const addToCart = (item) => {
  const existingItem = cart.find(cartItem => cartItem.id === item.id);
  if (existingItem) {
    existingItem.quantity += 1;
  } else {
    cart.push({ ...item, quantity: 1 });
  }
  localStorage.setItem('sushiCart', JSON.stringify(cart));
  return cart;
};

export const removeFromCart = (itemId) => {
  cart = cart.filter(item => item.id !== itemId);
  localStorage.setItem('sushiCart', JSON.stringify(cart));
  return cart;
};

export const updateCartQuantity = (itemId, quantity) => {
  const item = cart.find(cartItem => cartItem.id === itemId);
  if (item) {
    if (quantity <= 0) {
      return removeFromCart(itemId);
    }
    item.quantity = quantity;
    localStorage.setItem('sushiCart', JSON.stringify(cart));
  }
  return cart;
};

export const getCartTotal = () => {
  return cart.reduce((total, item) => total + (item.price * item.quantity), 0);
};

export const loadCart = () => {
  const savedCart = localStorage.getItem('sushiCart');
  if (savedCart) {
    cart = JSON.parse(savedCart);
  }
  return cart;
};

export const clearCart = () => {
  cart = [];
  localStorage.removeItem('sushiCart');
  return cart;
};
